import { CalendarSkeleton } from './loading';
import PageHeader from '@/components/PageHeader';
import SubContainer from '@/components/Container/SubContainer';
import { useCalendarStore } from './store/useCalendarStore';
import { useEffect } from 'react';
import { ErrorPage } from '@/components/ErrorPage';
import Container from '@/components/Container';
import Divider from '@/components/Divider';
import Button from '@/components/Button';
import { Calendar } from './components/calendar';
import { useLocation, useNavigate } from 'react-router-dom';
const WellbeingAwarenessDaysCalendarPageComponent = () => {
  const { onInit, page, loading, error } = useCalendarStore((state) => ({
    onInit: state.onInit,
    page: state.page,
    loading: state.loading,
    error: state.error,
  }));
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/wellbeing-awareness-days-calendar/') {
      const date = new Date();
      const currentMonth = date.toLocaleString('default', { month: 'long' }).toLowerCase();
      navigate(`/wellbeing-awareness-days-calendar/${currentMonth}`);
      return;
    }
  }, [navigate, location.pathname]);

  useEffect(() => {
    onInit();
  }, [onInit]);

  if (loading) {
    return <CalendarSkeleton />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <>
      <Container className="mt-sh-60 !gap-y-0">
        <SubContainer className="lg:col-start-11 lg:col-end-3">
          <PageHeader title={page?.title || ''} url="/" type="none" />
        </SubContainer>
        <SubContainer className="mt-sh-15 lg:col-start-11 lg:col-end-3">
          <h1 className=" !mb-sh-15 font-larken text-sh-36-48 !font-normal">{page?.title || ''}</h1>
          <p className=" text-sh-18-24">{page?.description || ''}</p>
          <Divider className="!my-sh-15" />
          <Button
            size="lg"
            className="mb-sh-15"
            onClick={() => window.open(page?.file?.data?.attributes?.url, '_blank')}>
            {page?.downloadButtonText || ''}
          </Button>
          <Calendar />
        </SubContainer>
      </Container>
    </>
  );
};

export default WellbeingAwarenessDaysCalendarPageComponent;
